import { cn } from '@/internationalization/cn'

export interface ProgressBarProps {
  /** 0–1. Clamped, so a caller cannot overflow the track. */
  value: number
  tone?: 'brand' | 'success' | 'warning' | 'danger'
  size?: 'sm' | 'md'
  label?: string
  className?: string
}

const TONES = {
  brand: 'bg-brand',
  success: 'bg-success',
  warning: 'bg-warning',
  danger: 'bg-danger',
} as const

export function ProgressBar({ value, tone = 'brand', size = 'sm', label, className }: ProgressBarProps) {
  const pct = Math.round(Math.min(1, Math.max(0, value)) * 100)
  return (
    <div className={cn('w-full', className)}>
      <div
        role="progressbar"
        aria-valuenow={pct}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={label}
        className={cn('w-full overflow-hidden rounded-full bg-surface-muted', size === 'sm' ? 'h-1.5' : 'h-2.5')}
      >
        <div
          className={cn('h-full rounded-full transition-all duration-slow', TONES[tone])}
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  )
}
